import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { BaseDto } from '@models/base/baseDto.model';
import { CreateEstadoPericiaRequest } from '@models/estadoPericia/createEstadoPericiaRequest.model';
import { UpdateEstadoPericiaRequest } from '@models/estadoPericia/updateEstadoPericiaRequest.model';
import { CreateHistorialExpedienteRequest } from '@models/historialExpediente/createHistorialExpedienteRequest.model';
import { UpdateHistorialExpedienteRequest } from '@models/historialExpediente/updateHistorialExpedienteRequest.model';
import { HistorialExpedienteDto } from '@models/historialExpediente/historialExpedienteDto';

@Injectable({
  providedIn: 'root'
})
export class HistorialExpedienteService {

  constructor(private http:HttpClient) {
  }

  create(createHistorialExpedienteRequest:CreateHistorialExpedienteRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/HistorialExpediente/Create",createHistorialExpedienteRequest);
  }

  update(updateHistorialExpedienteRequest:UpdateHistorialExpedienteRequest):Observable<any>
  {
    return  this.http.put<any>("/api/HistorialExpediente/Update",updateHistorialExpedienteRequest);
  }

  getAll():Observable<HistorialExpedienteDto[]> {
    return   this.http.get<HistorialExpedienteDto[]>("/api/HistorialExpediente/GetAll");
  }

  getAllByIdExpediente(idExpediente:number):Observable<HistorialExpedienteDto[]> {
    return   this.http.get<HistorialExpedienteDto[]>("/api/HistorialExpediente/GetAllByIdExpediente?idExpediente="+idExpediente);
  }

  getById(id:number):Observable<HistorialExpedienteDto>{
    return  this.http.get<HistorialExpedienteDto>("/api/HistorialExpediente/GetById?id="+id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/HistorialExpediente/Delete?id=" + id);
    else
      return of(null)
  }

}
